import { render } from "./BtnQuestionNext.vue?vue&type=template&id=d6ddfde8&scoped=true"
import script from "./BtnQuestionNext.vue?vue&type=script&lang=js"
export * from "./BtnQuestionNext.vue?vue&type=script&lang=js"

import "@/css/components/btn-question-next.css?vue&type=style&index=0&id=d6ddfde8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ddfde8"]])

export default __exports__